<template>
  <div class="mt-10">
    <div class="mb-4">
      <h3 class="fsize32 text-primary font-semibold mb-2">Side Effects</h3>
      <p class="fsize14">
        As a caregiver, it can be challenging to see your loved one go through
        the side effects of cancer treatment. While these side effects can be
        difficult to manage, it's essential to know that there are ways to
        alleviate them and make the patient more comfortable. In this blog, we
        will discuss some common side effects of cancer treatment and how to
        manage them.
      </p>
    </div>
    <div class="flex w-full gap-6">
      <div class="container">
        <div class="w-full flex gap-4 mt-10">
          <div class="w-1/2">
            <h2 class="fsize20 font-bold text4F0A4B text-center mb-1">
              Nausea and vomiting
            </h2>
            <p class="fsize14">
              Nausea and vomiting are common side effects of chemotherapy and
              radiation therapy. To manage nausea and vomiting, try the
              following: 
            </p>
            <div class="mt-2">
              <ul class="list-disc ml-4">
                <li class="fsize14 pb-1">Eat smaller, more frequent meals.</li>
                <li class="fsize14 pb-1">
                  Avoid foods that are greasy, spicy, or fried.
                </li>
                <li class="fsize14 pb-1">
                  Drink plenty of fluids to stay hydrated.
                </li>
                <li class="fsize14 pb-1">
                  Use anti-nausea medication as prescribed by the doctor.
                </li>
                <li class="fsize14 pb-1">
                  Try relaxation techniques such as deep breathing or
                  meditation.
                </li>
              </ul>
            </div>
          </div>
          <div class="w-1/2">
            <h2 class="fsize20 font-bold text4F0A4B text-center mb-1">
              Hair loss
            </h2>
            <p class="fsize14">
              Hair loss is a common side effect of chemotherapy. While it can be
              distressing, it's essential to remember that hair will grow back
              after treatment. To manage hair loss, try the following:
            </p>
            <div class="mt-2">
              <ul class="list-disc ml-4">
                <li class="fsize14 pb-1">
                  Wear a wig or scarf to cover the head.
                </li>
                <li class="fsize14 pb-1">
                  Use a gentle shampoo and avoid harsh chemicals or heat
                  styling.
                </li>

                <li class="fsize14 pb-1">
                  Cut hair short to make it easier to manage.
                </li>
                <li class="fsize14 pb-1">
                  Use a soft-bristled brush or comb to avoid further damage.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="my-12">
          <div class="my-4 w-full flex gap-4">
            <div class="w-1/2">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Nausea-and-vomiting.jpg"
                alt="cancer"
                class="first_img_var1 object-cover"
              />
            </div>
            <div class="w-1/2">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Hair-Loss.jpg"
                alt="cancer"
                class="second_img_var1 object-cover"
              />
            </div>
          </div>

          <div class="my-4 w-full flex gap-4">
            <div class="w-1/2">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Fatigue.jpg"
                alt="cancer"
                class="third_img_var1 object-cover"
              />
            </div>
            <div class="w-1/2">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Skin-irritation.jpg"
                alt="cancer"
                class="fourth_img_var1 object-cover"
              />
            </div>
          </div>
        </div>
        <div class="w-full flex gap-4">
          <div class="w-1/2">
            <h2 class="fsize20 font-bold text4F0A4B text-center mb-1">
              Fatigue
            </h2>
            <p class="fsize14">
              Fatigue is a common side effect of cancer treatment and can be
              challenging to manage. To manage fatigue, try the following:
            </p>
            <div class="mt-2">
              <ul class="list-disc ml-4">
                <li class="fsize14 pb-1">Rest when feeling tired.</li>
                <li class="fsize14 pb-1">
                  Prioritize tasks and conserve energy.
                </li>
                <li class="fsize14 pb-1">
                  Exercise regularly to help boost energy levels.
                </li>
                <li class="fsize14 pb-1">
                  Eat a well-balanced diet to help maintain energy levels.
                </li>
                <li class="fsize14 pb-1">
                  Ask for help from friends and family when needed.
                </li>
              </ul>
            </div>
          </div>
          <div class="w-1/2">
            <h2 class="fsize20 font-bold text4F0A4B text-center mb-1">
              Skin irritation
            </h2>
            <p class="fsize14">
              Radiation therapy can cause skin irritation and redness. To manage
              skin irritation, try the following:
            </p>
            <div class="mt-2">
              <ul class="list-disc ml-4">
                <li class="fsize14 pb-1">
                  Use mild soap and water to clean the affected area.
                </li>
                <li class="fsize14 pb-1">
                  Avoid tight clothing or clothing made from rough fabric.
                </li>

                <li class="fsize14 pb-1">
                  Apply a gentle moisturizer to the affected area.
                </li>
                <li class="fsize14 pb-1">
                  Avoid exposure to direct sunlight and wear protective clothing
                  when outside.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="w-1/6 border-left py-4 pl-4">
        <div class="border-bottom">
          <h2 class="fsize16 font-semibold pb-1">Our Latest Blogs</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            5 Essential Tips for Balancing Caregiving and Self-Care
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Navigating the Emotional Challenges of Being a...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            How to Create a Support Network for Caregivers
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Understanding the Legal Rights of Family Caregivers
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            10 Signs of Caregiver Burnout and How to Avoid It
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Latest Research</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            The Mental Health Impact of Caregiving on Family Members
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers Need ..
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            he Science Behind Compassion Fatigue: What...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Latest Research on the Emotional Toll of End-of-Life..
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers...
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Explore Resources</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Emotional First Aid</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Caregiver Coach Program</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Mental health Awareness</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Medical Terminology</p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">Caring at Caregiver sath</p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">
            Helpful Links and Collaborations
          </h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Duis volutpat pulvinar nisi
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            et rutrum nisl rhoncus nec
          </p>
        </div>
      </div>/// -->

      <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
    </div>
  </div>
</template>

<script>
import SideBlogs from "./components/SideBlogs.vue";

export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.first_img_var1 {
  height: 280px;
  width: 100%;
  border-radius: 0 80px 0 80px;
}

.second_img_var1 {
  height: 280px;
  width: 100%;
  border-radius: 80px 0 80px 0;
}
.third_img_var1 {
  height: 280px;
  width: 100%;
  border-radius: 80px 0 80px 0;
}

.fourth_img_var1 {
  height: 280px;
  width: 100%;
  border-radius: 0 80px 0 80px;
}
</style>
